export const exteriorView03ImageOptions = {
	angle:"ExteriorView03",
	staticOptions:{
		HullColorways:1,
		Bowsprit:1,
		HullTreatment:1,
		TeakDeck:1,
		TeakOnSideDecks:1,
		BathingPlatform:1,
		SelfTacker:1,
		TeakOnCoachRoof:1,
		MastAndBoom:1,
		BoomCover:1,
		OutboardBracket:1,
		CockpitBenchExtentions:1,
		CockpitCushionBackrests:1,
		CockpitCushionSeats:1,
		CockpitFabric:1,
		SprayhoodFabric:1,
		GTSeat:1,
		Flag:1,
	},
	mattes:[
		{
			option:"HullColorways",
			dependency:null
		},
		{
			option:"Bowsprit",
			dependency:"HullColorways"
		},
		{
			option:"HullTreatment",
			dependency:null
		},
		{
			option:"MastAndBoom",
			dependency:null
		},
		{
			option:"BoomCover",
			dependency:null
		},
		{
			option:"OutboardBracket",
			dependency:null
		},
		{
			option:"GTSeat",
			dependency:"CockpitFabric"
		},
	],
	overlays:[
		{
			option:"Flag",
			dependency:null
		},
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/ExteriorView03.js